export type Box<T> = [T, T, T, T]
